import {inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {environment} from '../environments/environment';

/** "Seire" → "Seire - CRM26" (" - CRM26 Acceptatie" on acceptance); without a title only the app name. */
export function browserTitle(title?: string | null): string {
    return title ? `${title}${environment.titleAppend}` : environment.titleAppend.replace(/^\s*-\s*/, '');
}

/**
 * Sets the browser tab title from the `title` of the active route.
 * Pages whose title depends on loaded data (a platform name, the report filters) have no `title` on their route
 * and set it themselves with `Title.setTitle(browserTitle(...))`.
 */
@Injectable()
export class PageTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const title = this.buildTitle(snapshot);
        if (title !== undefined) {
            this.title.setTitle(browserTitle(title));
        }
    }
}
